/**
 * This file is auto-generated from Country.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */
export const AD = lang => {
    switch (lang) {
        case 'en':
            return 'Andorra';
        case 'pl':
            return 'Andora';
        case 'de':
            return 'Andorra';
    }
};
export const AE = lang => {
    switch (lang) {
        case 'en':
            return 'United Arab Emirates';
        case 'pl':
            return 'Zjednoczone Emiraty Arabskie';
        case 'de':
            return 'Vereinigte Arabische Emirate';
    }
};
export const AF = lang => {
    switch (lang) {
        case 'en':
            return 'Afghanistan';
        case 'pl':
            return 'Afganistan';
        case 'de':
            return 'Afghanistan';
    }
};
export const AG = lang => {
    switch (lang) {
        case 'en':
            return 'Antigua and Barbuda';
        case 'pl':
            return 'Antigua i Barbuda';
        case 'de':
            return 'Antigua und Barbuda';
    }
};
export const AI = lang => {
    switch (lang) {
        case 'en':
            return 'Anguilla';
        case 'pl':
            return 'Anguilla';
        case 'de':
            return 'Anguilla';
    }
};
export const AL = lang => {
    switch (lang) {
        case 'en':
            return 'Albania';
        case 'pl':
            return 'Albania';
        case 'de':
            return 'Albanien';
    }
};
export const AM = lang => {
    switch (lang) {
        case 'en':
            return 'Armenia';
        case 'pl':
            return 'Armenia';
        case 'de':
            return 'Armenien';
    }
};
export const AO = lang => {
    switch (lang) {
        case 'en':
            return 'Angola';
        case 'pl':
            return 'Angola';
        case 'de':
            return 'Angola';
    }
};
export const AQ = lang => {
    switch (lang) {
        case 'en':
            return 'Antarctica';
        case 'pl':
            return 'Antarktyda';
        case 'de':
            return 'Antarktis';
    }
};
export const AR = lang => {
    switch (lang) {
        case 'en':
            return 'Argentina';
        case 'pl':
            return 'Argentyna';
        case 'de':
            return 'Argentinien';
    }
};
export const AS = lang => {
    switch (lang) {
        case 'en':
            return 'American Samoa';
        case 'pl':
            return 'Samoa Amerykańskie';
        case 'de':
            return 'Amerikanisch-Samoa';
    }
};
export const AT = lang => {
    switch (lang) {
        case 'en':
            return 'Austria';
        case 'pl':
            return 'Austria';
        case 'de':
            return 'Österreich';
    }
};
export const AU = lang => {
    switch (lang) {
        case 'en':
            return 'Australia';
        case 'pl':
            return 'Australia';
        case 'de':
            return 'Australien';
    }
};
export const AW = lang => {
    switch (lang) {
        case 'en':
            return 'Aruba';
        case 'pl':
            return 'Aruba';
        case 'de':
            return 'Aruba';
    }
};
export const AX = lang => {
    switch (lang) {
        case 'en':
            return 'Åland Islands';
        case 'pl':
            return 'Wyspy Alandzkie';
        case 'de':
            return 'Ålandinseln';
    }
};
export const AZ = lang => {
    switch (lang) {
        case 'en':
            return 'Azerbaijan';
        case 'pl':
            return 'Azerbejdżan';
        case 'de':
            return 'Aserbaidschan';
    }
};
export const BA = lang => {
    switch (lang) {
        case 'en':
            return 'Bosnia and Herzegovina';
        case 'pl':
            return 'Bośnia i Hercegowina';
        case 'de':
            return 'Bosnien und Herzegowina';
    }
};
export const BB = lang => {
    switch (lang) {
        case 'en':
            return 'Barbados';
        case 'pl':
            return 'Barbados';
        case 'de':
            return 'Barbados';
    }
};
export const BD = lang => {
    switch (lang) {
        case 'en':
            return 'Bangladesh';
        case 'pl':
            return 'Bangladesz';
        case 'de':
            return 'Bangladesch';
    }
};
export const BE = lang => {
    switch (lang) {
        case 'en':
            return 'Belgium';
        case 'pl':
            return 'Belgia';
        case 'de':
            return 'Belgien';
    }
};
export const BF = lang => {
    switch (lang) {
        case 'en':
            return 'Burkina Faso';
        case 'pl':
            return 'Burkina Faso';
        case 'de':
            return 'Burkina Faso';
    }
};
export const BG = lang => {
    switch (lang) {
        case 'en':
            return 'Bulgaria';
        case 'pl':
            return 'Bułgaria';
        case 'de':
            return 'Bulgarien';
    }
};
export const BH = lang => {
    switch (lang) {
        case 'en':
            return 'Bahrain';
        case 'pl':
            return 'Bahrajn';
        case 'de':
            return 'Bahrain';
    }
};
export const BI = lang => {
    switch (lang) {
        case 'en':
            return 'Burundi';
        case 'pl':
            return 'Burundi';
        case 'de':
            return 'Burundi';
    }
};
export const BJ = lang => {
    switch (lang) {
        case 'en':
            return 'Benin';
        case 'pl':
            return 'Benin';
        case 'de':
            return 'Benin';
    }
};
export const BL = lang => {
    switch (lang) {
        case 'en':
            return 'Saint Barthélemy';
        case 'pl':
            return 'Saint-Barthélemy';
        case 'de':
            return 'Saint-Barthélemy';
    }
};
export const BM = lang => {
    switch (lang) {
        case 'en':
            return 'Bermuda';
        case 'pl':
            return 'Bermudy';
        case 'de':
            return 'Bermuda';
    }
};
export const BN = lang => {
    switch (lang) {
        case 'en':
            return 'Brunei';
        case 'pl':
            return 'Brunei';
        case 'de':
            return 'Brunei';
    }
};
export const BO = lang => {
    switch (lang) {
        case 'en':
            return 'Bolivia';
        case 'pl':
            return 'Boliwia';
        case 'de':
            return 'Bolivien';
    }
};
export const BQ = lang => {
    switch (lang) {
        case 'en':
            return 'Bonaire, Sint Eustatius and Saba';
        case 'pl':
            return 'Bonaire, Sint Eustatius i Saba';
        case 'de':
            return 'Bonaire, Sint Eustatius und Saba';
    }
};
export const BR = lang => {
    switch (lang) {
        case 'en':
            return 'Brazil';
        case 'pl':
            return 'Brazylia';
        case 'de':
            return 'Brasilien';
    }
};
export const BS = lang => {
    switch (lang) {
        case 'en':
            return 'Bahamas';
        case 'pl':
            return 'Bahamy';
        case 'de':
            return 'Bahamas';
    }
};
export const BT = lang => {
    switch (lang) {
        case 'en':
            return 'Bhutan';
        case 'pl':
            return 'Bhutan';
        case 'de':
            return 'Bhutan';
    }
};
export const BV = lang => {
    switch (lang) {
        case 'en':
            return 'Bouvet Island';
        case 'pl':
            return 'Wyspa Bouveta';
        case 'de':
            return 'Bouvetinsel';
    }
};
export const BW = lang => {
    switch (lang) {
        case 'en':
            return 'Botswana';
        case 'pl':
            return 'Botswana';
        case 'de':
            return 'Botsuana';
    }
};
export const BY = lang => {
    switch (lang) {
        case 'en':
            return 'Belarus';
        case 'pl':
            return 'Białoruś';
        case 'de':
            return 'Belarus';
    }
};
export const BZ = lang => {
    switch (lang) {
        case 'en':
            return 'Belize';
        case 'pl':
            return 'Belize';
        case 'de':
            return 'Belize';
    }
};
export const CA = lang => {
    switch (lang) {
        case 'en':
            return 'Canada';
        case 'pl':
            return 'Kanada';
        case 'de':
            return 'Kanada';
    }
};
export const CC = lang => {
    switch (lang) {
        case 'en':
            return 'Cocos (Keeling) Islands';
        case 'pl':
            return 'Wyspy Kokosowe';
        case 'de':
            return 'Kokosinseln';
    }
};
export const CD = lang => {
    switch (lang) {
        case 'en':
            return 'Congo (Democratic Republic)';
        case 'pl':
            return 'Kongo (Demokratyczna Republika)';
        case 'de':
            return 'Kongo (Demokratische Republik)';
    }
};
export const CF = lang => {
    switch (lang) {
        case 'en':
            return 'Central African Republic';
        case 'pl':
            return 'Republika Środkowoafrykańska';
        case 'de':
            return 'Zentralafrikanische Republik';
    }
};
export const CG = lang => {
    switch (lang) {
        case 'en':
            return 'Congo (Republic)';
        case 'pl':
            return 'Kongo (Republika)';
        case 'de':
            return 'Kongo (Republik)';
    }
};
export const CH = lang => {
    switch (lang) {
        case 'en':
            return 'Switzerland';
        case 'pl':
            return 'Szwajcaria';
        case 'de':
            return 'Schweiz';
    }
};
export const CI = lang => {
    switch (lang) {
        case 'en':
            return "Côte d'Ivoire";
        case 'pl':
            return 'Wybrzeże Kości Słoniowej';
        case 'de':
            return 'Elfenbeinküste';
    }
};
export const CK = lang => {
    switch (lang) {
        case 'en':
            return 'Cook Islands';
        case 'pl':
            return 'Wyspy Cooka';
        case 'de':
            return 'Cookinseln';
    }
};
export const CL = lang => {
    switch (lang) {
        case 'en':
            return 'Chile';
        case 'pl':
            return 'Chile';
        case 'de':
            return 'Chile';
    }
};
export const CM = lang => {
    switch (lang) {
        case 'en':
            return 'Cameroon';
        case 'pl':
            return 'Kamerun';
        case 'de':
            return 'Kamerun';
    }
};
export const CN = lang => {
    switch (lang) {
        case 'en':
            return 'China';
        case 'pl':
            return 'Chiny';
        case 'de':
            return 'China';
    }
};
export const CO = lang => {
    switch (lang) {
        case 'en':
            return 'Colombia';
        case 'pl':
            return 'Kolumbia';
        case 'de':
            return 'Kolumbien';
    }
};
export const CR = lang => {
    switch (lang) {
        case 'en':
            return 'Costa Rica';
        case 'pl':
            return 'Kostaryka';
        case 'de':
            return 'Costa Rica';
    }
};
export const CU = lang => {
    switch (lang) {
        case 'en':
            return 'Cuba';
        case 'pl':
            return 'Kuba';
        case 'de':
            return 'Kuba';
    }
};
export const CV = lang => {
    switch (lang) {
        case 'en':
            return 'Cabo Verde';
        case 'pl':
            return 'Republika Zielonego Przylądka';
        case 'de':
            return 'Kap Verde';
    }
};
export const CW = lang => {
    switch (lang) {
        case 'en':
            return 'Curaçao';
        case 'pl':
            return 'Curaçao';
        case 'de':
            return 'Curaçao';
    }
};
export const CX = lang => {
    switch (lang) {
        case 'en':
            return 'Christmas Island';
        case 'pl':
            return 'Wyspa Bożego Narodzenia';
        case 'de':
            return 'Weihnachtsinsel';
    }
};
export const CY = lang => {
    switch (lang) {
        case 'en':
            return 'Cyprus';
        case 'pl':
            return 'Cypr';
        case 'de':
            return 'Zypern';
    }
};
export const CZ = lang => {
    switch (lang) {
        case 'en':
            return 'Czechia';
        case 'pl':
            return 'Czechy';
        case 'de':
            return 'Tschechien';
    }
};
export const DE = lang => {
    switch (lang) {
        case 'en':
            return 'Germany';
        case 'pl':
            return 'Niemcy';
        case 'de':
            return 'Deutschland';
    }
};
export const DJ = lang => {
    switch (lang) {
        case 'en':
            return 'Djibouti';
        case 'pl':
            return 'Dżibuti';
        case 'de':
            return 'Dschibuti';
    }
};
export const DK = lang => {
    switch (lang) {
        case 'en':
            return 'Denmark';
        case 'pl':
            return 'Dania';
        case 'de':
            return 'Dänemark';
    }
};
export const DM = lang => {
    switch (lang) {
        case 'en':
            return 'Dominica';
        case 'pl':
            return 'Dominika';
        case 'de':
            return 'Dominica';
    }
};
export const DO = lang => {
    switch (lang) {
        case 'en':
            return 'Dominican Republic';
        case 'pl':
            return 'Dominikana';
        case 'de':
            return 'Dominikanische Republik';
    }
};
export const DZ = lang => {
    switch (lang) {
        case 'en':
            return 'Algeria';
        case 'pl':
            return 'Algieria';
        case 'de':
            return 'Algerien';
    }
};
export const EC = lang => {
    switch (lang) {
        case 'en':
            return 'Ecuador';
        case 'pl':
            return 'Ekwador';
        case 'de':
            return 'Ecuador';
    }
};
export const EE = lang => {
    switch (lang) {
        case 'en':
            return 'Estonia';
        case 'pl':
            return 'Estonia';
        case 'de':
            return 'Estland';
    }
};
export const EG = lang => {
    switch (lang) {
        case 'en':
            return 'Egypt';
        case 'pl':
            return 'Egipt';
        case 'de':
            return 'Ägypten';
    }
};
export const EH = lang => {
    switch (lang) {
        case 'en':
            return 'Western Sahara';
        case 'pl':
            return 'Sahara Zachodnia';
        case 'de':
            return 'Westsahara';
    }
};
export const ER = lang => {
    switch (lang) {
        case 'en':
            return 'Eritrea';
        case 'pl':
            return 'Erytrea';
        case 'de':
            return 'Eritrea';
    }
};
export const ES = lang => {
    switch (lang) {
        case 'en':
            return 'Spain';
        case 'pl':
            return 'Hiszpania';
        case 'de':
            return 'Spanien';
    }
};
export const ET = lang => {
    switch (lang) {
        case 'en':
            return 'Ethiopia';
        case 'pl':
            return 'Etiopia';
        case 'de':
            return 'Äthiopien';
    }
};
export const FI = lang => {
    switch (lang) {
        case 'en':
            return 'Finland';
        case 'pl':
            return 'Finlandia';
        case 'de':
            return 'Finnland';
    }
};
export const FJ = lang => {
    switch (lang) {
        case 'en':
            return 'Fiji';
        case 'pl':
            return 'Fidżi';
        case 'de':
            return 'Fidschi';
    }
};
export const FK = lang => {
    switch (lang) {
        case 'en':
            return 'Falkland Islands';
        case 'pl':
            return 'Falklandy';
        case 'de':
            return 'Falklandinseln';
    }
};
export const FM = lang => {
    switch (lang) {
        case 'en':
            return 'Micronesia';
        case 'pl':
            return 'Mikronezja';
        case 'de':
            return 'Mikronesien';
    }
};
export const FO = lang => {
    switch (lang) {
        case 'en':
            return 'Faroe Islands';
        case 'pl':
            return 'Wyspy Owcze';
        case 'de':
            return 'Färöer';
    }
};
export const FR = lang => {
    switch (lang) {
        case 'en':
            return 'France';
        case 'pl':
            return 'Francja';
        case 'de':
            return 'Frankreich';
    }
};
export const GA = lang => {
    switch (lang) {
        case 'en':
            return 'Gabon';
        case 'pl':
            return 'Gabon';
        case 'de':
            return 'Gabun';
    }
};
export const GB = lang => {
    switch (lang) {
        case 'en':
            return 'United Kingdom';
        case 'pl':
            return 'Wielka Brytania';
        case 'de':
            return 'Vereinigtes Königreich';
    }
};
export const GD = lang => {
    switch (lang) {
        case 'en':
            return 'Grenada';
        case 'pl':
            return 'Grenada';
        case 'de':
            return 'Grenada';
    }
};
export const GE = lang => {
    switch (lang) {
        case 'en':
            return 'Georgia';
        case 'pl':
            return 'Gruzja';
        case 'de':
            return 'Georgien';
    }
};
export const GF = lang => {
    switch (lang) {
        case 'en':
            return 'French Guiana';
        case 'pl':
            return 'Gujana Francuska';
        case 'de':
            return 'Französisch-Guayana';
    }
};
export const GG = lang => {
    switch (lang) {
        case 'en':
            return 'Guernsey';
        case 'pl':
            return 'Guernsey';
        case 'de':
            return 'Guernsey';
    }
};
export const GH = lang => {
    switch (lang) {
        case 'en':
            return 'Ghana';
        case 'pl':
            return 'Ghana';
        case 'de':
            return 'Ghana';
    }
};
export const GI = lang => {
    switch (lang) {
        case 'en':
            return 'Gibraltar';
        case 'pl':
            return 'Gibraltar';
        case 'de':
            return 'Gibraltar';
    }
};
export const GL = lang => {
    switch (lang) {
        case 'en':
            return 'Greenland';
        case 'pl':
            return 'Grenlandia';
        case 'de':
            return 'Grönland';
    }
};
export const GM = lang => {
    switch (lang) {
        case 'en':
            return 'Gambia';
        case 'pl':
            return 'Gambia';
        case 'de':
            return 'Gambia';
    }
};
export const GN = lang => {
    switch (lang) {
        case 'en':
            return 'Guinea';
        case 'pl':
            return 'Gwinea';
        case 'de':
            return 'Guinea';
    }
};
export const GP = lang => {
    switch (lang) {
        case 'en':
            return 'Guadeloupe';
        case 'pl':
            return 'Gwadelupa';
        case 'de':
            return 'Guadeloupe';
    }
};
export const GQ = lang => {
    switch (lang) {
        case 'en':
            return 'Equatorial Guinea';
        case 'pl':
            return 'Gwinea Równikowa';
        case 'de':
            return 'Äquatorialguinea';
    }
};
export const GR = lang => {
    switch (lang) {
        case 'en':
            return 'Greece';
        case 'pl':
            return 'Grecja';
        case 'de':
            return 'Griechenland';
    }
};
export const GS = lang => {
    switch (lang) {
        case 'en':
            return 'South Georgia and the South Sandwich Islands';
        case 'pl':
            return 'Georgia Południowa i Sandwich Południowy';
        case 'de':
            return 'Südgeorgien und die Südlichen Sandwichinseln';
    }
};
export const GT = lang => {
    switch (lang) {
        case 'en':
            return 'Guatemala';
        case 'pl':
            return 'Gwatemala';
        case 'de':
            return 'Guatemala';
    }
};
export const GU = lang => {
    switch (lang) {
        case 'en':
            return 'Guam';
        case 'pl':
            return 'Guam';
        case 'de':
            return 'Guam';
    }
};
export const GW = lang => {
    switch (lang) {
        case 'en':
            return 'Guinea-Bissau';
        case 'pl':
            return 'Gwinea Bissau';
        case 'de':
            return 'Guinea-Bissau';
    }
};
export const GY = lang => {
    switch (lang) {
        case 'en':
            return 'Guyana';
        case 'pl':
            return 'Gujana';
        case 'de':
            return 'Guyana';
    }
};
export const HK = lang => {
    switch (lang) {
        case 'en':
            return 'Hong Kong';
        case 'pl':
            return 'Hongkong';
        case 'de':
            return 'Hongkong';
    }
};
export const HM = lang => {
    switch (lang) {
        case 'en':
            return 'Heard Island and McDonald Islands';
        case 'pl':
            return 'Wyspy Heard i McDonalda';
        case 'de':
            return 'Heard und McDonaldinseln';
    }
};
export const HN = lang => {
    switch (lang) {
        case 'en':
            return 'Honduras';
        case 'pl':
            return 'Honduras';
        case 'de':
            return 'Honduras';
    }
};
export const HR = lang => {
    switch (lang) {
        case 'en':
            return 'Croatia';
        case 'pl':
            return 'Chorwacja';
        case 'de':
            return 'Kroatien';
    }
};
export const HT = lang => {
    switch (lang) {
        case 'en':
            return 'Haiti';
        case 'pl':
            return 'Haiti';
        case 'de':
            return 'Haiti';
    }
};
export const HU = lang => {
    switch (lang) {
        case 'en':
            return 'Hungary';
        case 'pl':
            return 'Węgry';
        case 'de':
            return 'Ungarn';
    }
};
export const ID = lang => {
    switch (lang) {
        case 'en':
            return 'Indonesia';
        case 'pl':
            return 'Indonezja';
        case 'de':
            return 'Indonesien';
    }
};
export const IE = lang => {
    switch (lang) {
        case 'en':
            return 'Ireland';
        case 'pl':
            return 'Irlandia';
        case 'de':
            return 'Irland';
    }
};
export const IL = lang => {
    switch (lang) {
        case 'en':
            return 'Israel';
        case 'pl':
            return 'Izrael';
        case 'de':
            return 'Israel';
    }
};
export const IM = lang => {
    switch (lang) {
        case 'en':
            return 'Isle of Man';
        case 'pl':
            return 'Wyspa Man';
        case 'de':
            return 'Isle of Man';
    }
};
export const IN = lang => {
    switch (lang) {
        case 'en':
            return 'India';
        case 'pl':
            return 'Indie';
        case 'de':
            return 'Indien';
    }
};
export const IO = lang => {
    switch (lang) {
        case 'en':
            return 'British Indian Ocean Territory';
        case 'pl':
            return 'Brytyjskie Terytorium Oceanu Indyjskiego';
        case 'de':
            return 'Britisches Territorium im Indischen Ozean';
    }
};
export const IQ = lang => {
    switch (lang) {
        case 'en':
            return 'Iraq';
        case 'pl':
            return 'Irak';
        case 'de':
            return 'Irak';
    }
};
export const IR = lang => {
    switch (lang) {
        case 'en':
            return 'Iran';
        case 'pl':
            return 'Iran';
        case 'de':
            return 'Iran';
    }
};
export const IS = lang => {
    switch (lang) {
        case 'en':
            return 'Iceland';
        case 'pl':
            return 'Islandia';
        case 'de':
            return 'Island';
    }
};
export const IT = lang => {
    switch (lang) {
        case 'en':
            return 'Italy';
        case 'pl':
            return 'Włochy';
        case 'de':
            return 'Italien';
    }
};
export const JE = lang => {
    switch (lang) {
        case 'en':
            return 'Jersey';
        case 'pl':
            return 'Jersey';
        case 'de':
            return 'Jersey';
    }
};
export const JM = lang => {
    switch (lang) {
        case 'en':
            return 'Jamaica';
        case 'pl':
            return 'Jamajka';
        case 'de':
            return 'Jamaika';
    }
};
export const JO = lang => {
    switch (lang) {
        case 'en':
            return 'Jordan';
        case 'pl':
            return 'Jordania';
        case 'de':
            return 'Jordanien';
    }
};
export const JP = lang => {
    switch (lang) {
        case 'en':
            return 'Japan';
        case 'pl':
            return 'Japonia';
        case 'de':
            return 'Japan';
    }
};
export const KE = lang => {
    switch (lang) {
        case 'en':
            return 'Kenya';
        case 'pl':
            return 'Kenia';
        case 'de':
            return 'Kenia';
    }
};
export const KG = lang => {
    switch (lang) {
        case 'en':
            return 'Kyrgyzstan';
        case 'pl':
            return 'Kirgistan';
        case 'de':
            return 'Kirgisistan';
    }
};
export const KH = lang => {
    switch (lang) {
        case 'en':
            return 'Cambodia';
        case 'pl':
            return 'Kambodża';
        case 'de':
            return 'Kambodscha';
    }
};
export const KI = lang => {
    switch (lang) {
        case 'en':
            return 'Kiribati';
        case 'pl':
            return 'Kiribati';
        case 'de':
            return 'Kiribati';
    }
};
export const KM = lang => {
    switch (lang) {
        case 'en':
            return 'Comoros';
        case 'pl':
            return 'Komory';
        case 'de':
            return 'Komoren';
    }
};
export const KN = lang => {
    switch (lang) {
        case 'en':
            return 'Saint Kitts and Nevis';
        case 'pl':
            return 'Saint Kitts i Nevis';
        case 'de':
            return 'St. Kitts und Nevis';
    }
};
export const KP = lang => {
    switch (lang) {
        case 'en':
            return 'North Korea';
        case 'pl':
            return 'Korea Północna';
        case 'de':
            return 'Nordkorea';
    }
};
export const KR = lang => {
    switch (lang) {
        case 'en':
            return 'South Korea';
        case 'pl':
            return 'Korea Południowa';
        case 'de':
            return 'Südkorea';
    }
};
export const KW = lang => {
    switch (lang) {
        case 'en':
            return 'Kuwait';
        case 'pl':
            return 'Kuwejt';
        case 'de':
            return 'Kuwait';
    }
};
export const KY = lang => {
    switch (lang) {
        case 'en':
            return 'Cayman Islands';
        case 'pl':
            return 'Kajmany';
        case 'de':
            return 'Kaimaninseln';
    }
};
export const KZ = lang => {
    switch (lang) {
        case 'en':
            return 'Kazakhstan';
        case 'pl':
            return 'Kazachstan';
        case 'de':
            return 'Kasachstan';
    }
};
export const LA = lang => {
    switch (lang) {
        case 'en':
            return 'Laos';
        case 'pl':
            return 'Laos';
        case 'de':
            return 'Laos';
    }
};
export const LB = lang => {
    switch (lang) {
        case 'en':
            return 'Lebanon';
        case 'pl':
            return 'Liban';
        case 'de':
            return 'Libanon';
    }
};
export const LC = lang => {
    switch (lang) {
        case 'en':
            return 'Saint Lucia';
        case 'pl':
            return 'Saint Lucia';
        case 'de':
            return 'St. Lucia';
    }
};
export const LI = lang => {
    switch (lang) {
        case 'en':
            return 'Liechtenstein';
        case 'pl':
            return 'Liechtenstein';
        case 'de':
            return 'Liechtenstein';
    }
};
export const LK = lang => {
    switch (lang) {
        case 'en':
            return 'Sri Lanka';
        case 'pl':
            return 'Sri Lanka';
        case 'de':
            return 'Sri Lanka';
    }
};
export const LR = lang => {
    switch (lang) {
        case 'en':
            return 'Liberia';
        case 'pl':
            return 'Liberia';
        case 'de':
            return 'Liberia';
    }
};
export const LS = lang => {
    switch (lang) {
        case 'en':
            return 'Lesotho';
        case 'pl':
            return 'Lesotho';
        case 'de':
            return 'Lesotho';
    }
};
export const LT = lang => {
    switch (lang) {
        case 'en':
            return 'Lithuania';
        case 'pl':
            return 'Litwa';
        case 'de':
            return 'Litauen';
    }
};
export const LU = lang => {
    switch (lang) {
        case 'en':
            return 'Luxembourg';
        case 'pl':
            return 'Luksemburg';
        case 'de':
            return 'Luxemburg';
    }
};
export const LV = lang => {
    switch (lang) {
        case 'en':
            return 'Latvia';
        case 'pl':
            return 'Łotwa';
        case 'de':
            return 'Lettland';
    }
};
export const LY = lang => {
    switch (lang) {
        case 'en':
            return 'Libya';
        case 'pl':
            return 'Libia';
        case 'de':
            return 'Libyen';
    }
};
export const MA = lang => {
    switch (lang) {
        case 'en':
            return 'Morocco';
        case 'pl':
            return 'Maroko';
        case 'de':
            return 'Marokko';
    }
};
export const MC = lang => {
    switch (lang) {
        case 'en':
            return 'Monaco';
        case 'pl':
            return 'Monako';
        case 'de':
            return 'Monaco';
    }
};
export const MD = lang => {
    switch (lang) {
        case 'en':
            return 'Moldova';
        case 'pl':
            return 'Mołdawia';
        case 'de':
            return 'Moldau';
    }
};
export const ME = lang => {
    switch (lang) {
        case 'en':
            return 'Montenegro';
        case 'pl':
            return 'Czarnogóra';
        case 'de':
            return 'Montenegro';
    }
};
export const MF = lang => {
    switch (lang) {
        case 'en':
            return 'Saint Martin';
        case 'pl':
            return 'Saint-Martin';
        case 'de':
            return 'Saint-Martin';
    }
};
export const MG = lang => {
    switch (lang) {
        case 'en':
            return 'Madagascar';
        case 'pl':
            return 'Madagaskar';
        case 'de':
            return 'Madagaskar';
    }
};
export const MH = lang => {
    switch (lang) {
        case 'en':
            return 'Marshall Islands';
        case 'pl':
            return 'Wyspy Marshalla';
        case 'de':
            return 'Marshallinseln';
    }
};
export const MK = lang => {
    switch (lang) {
        case 'en':
            return 'North Macedonia';
        case 'pl':
            return 'Macedonia Północna';
        case 'de':
            return 'Nordmazedonien';
    }
};
export const ML = lang => {
    switch (lang) {
        case 'en':
            return 'Mali';
        case 'pl':
            return 'Mali';
        case 'de':
            return 'Mali';
    }
};
export const MM = lang => {
    switch (lang) {
        case 'en':
            return 'Myanmar';
        case 'pl':
            return 'Mjanma';
        case 'de':
            return 'Myanmar';
    }
};
export const MN = lang => {
    switch (lang) {
        case 'en':
            return 'Mongolia';
        case 'pl':
            return 'Mongolia';
        case 'de':
            return 'Mongolei';
    }
};
export const MO = lang => {
    switch (lang) {
        case 'en':
            return 'Macao';
        case 'pl':
            return 'Makau';
        case 'de':
            return 'Macau';
    }
};
export const MP = lang => {
    switch (lang) {
        case 'en':
            return 'Northern Mariana Islands';
        case 'pl':
            return 'Mariany Północne';
        case 'de':
            return 'Nördliche Marianen';
    }
};
export const MQ = lang => {
    switch (lang) {
        case 'en':
            return 'Martinique';
        case 'pl':
            return 'Martynika';
        case 'de':
            return 'Martinique';
    }
};
export const MR = lang => {
    switch (lang) {
        case 'en':
            return 'Mauritania';
        case 'pl':
            return 'Mauretania';
        case 'de':
            return 'Mauretanien';
    }
};
export const MS = lang => {
    switch (lang) {
        case 'en':
            return 'Montserrat';
        case 'pl':
            return 'Montserrat';
        case 'de':
            return 'Montserrat';
    }
};
export const MT = lang => {
    switch (lang) {
        case 'en':
            return 'Malta';
        case 'pl':
            return 'Malta';
        case 'de':
            return 'Malta';
    }
};
export const MU = lang => {
    switch (lang) {
        case 'en':
            return 'Mauritius';
        case 'pl':
            return 'Mauritius';
        case 'de':
            return 'Mauritius';
    }
};
export const MV = lang => {
    switch (lang) {
        case 'en':
            return 'Maldives';
        case 'pl':
            return 'Malediwy';
        case 'de':
            return 'Malediven';
    }
};
export const MW = lang => {
    switch (lang) {
        case 'en':
            return 'Malawi';
        case 'pl':
            return 'Malawi';
        case 'de':
            return 'Malawi';
    }
};
export const MX = lang => {
    switch (lang) {
        case 'en':
            return 'Mexico';
        case 'pl':
            return 'Meksyk';
        case 'de':
            return 'Mexiko';
    }
};
export const MY = lang => {
    switch (lang) {
        case 'en':
            return 'Malaysia';
        case 'pl':
            return 'Malezja';
        case 'de':
            return 'Malaysia';
    }
};
export const MZ = lang => {
    switch (lang) {
        case 'en':
            return 'Mozambique';
        case 'pl':
            return 'Mozambik';
        case 'de':
            return 'Mosambik';
    }
};
export const NA = lang => {
    switch (lang) {
        case 'en':
            return 'Namibia';
        case 'pl':
            return 'Namibia';
        case 'de':
            return 'Namibia';
    }
};
export const NC = lang => {
    switch (lang) {
        case 'en':
            return 'New Caledonia';
        case 'pl':
            return 'Nowa Kaledonia';
        case 'de':
            return 'Neukaledonien';
    }
};
export const NE = lang => {
    switch (lang) {
        case 'en':
            return 'Niger';
        case 'pl':
            return 'Niger';
        case 'de':
            return 'Niger';
    }
};
export const NF = lang => {
    switch (lang) {
        case 'en':
            return 'Norfolk Island';
        case 'pl':
            return 'Norfolk';
        case 'de':
            return 'Norfolkinsel';
    }
};
export const NG = lang => {
    switch (lang) {
        case 'en':
            return 'Nigeria';
        case 'pl':
            return 'Nigeria';
        case 'de':
            return 'Nigeria';
    }
};
export const NI = lang => {
    switch (lang) {
        case 'en':
            return 'Nicaragua';
        case 'pl':
            return 'Nikaragua';
        case 'de':
            return 'Nicaragua';
    }
};
export const NL = lang => {
    switch (lang) {
        case 'en':
            return 'Netherlands';
        case 'pl':
            return 'Holandia';
        case 'de':
            return 'Niederlande';
    }
};
export const NO = lang => {
    switch (lang) {
        case 'en':
            return 'Norway';
        case 'pl':
            return 'Norwegia';
        case 'de':
            return 'Norwegen';
    }
};
export const NP = lang => {
    switch (lang) {
        case 'en':
            return 'Nepal';
        case 'pl':
            return 'Nepal';
        case 'de':
            return 'Nepal';
    }
};
export const NR = lang => {
    switch (lang) {
        case 'en':
            return 'Nauru';
        case 'pl':
            return 'Nauru';
        case 'de':
            return 'Nauru';
    }
};
export const NU = lang => {
    switch (lang) {
        case 'en':
            return 'Niue';
        case 'pl':
            return 'Niue';
        case 'de':
            return 'Niue';
    }
};
export const NZ = lang => {
    switch (lang) {
        case 'en':
            return 'New Zealand';
        case 'pl':
            return 'Nowa Zelandia';
        case 'de':
            return 'Neuseeland';
    }
};
export const OM = lang => {
    switch (lang) {
        case 'en':
            return 'Oman';
        case 'pl':
            return 'Oman';
        case 'de':
            return 'Oman';
    }
};
export const PA = lang => {
    switch (lang) {
        case 'en':
            return 'Panama';
        case 'pl':
            return 'Panama';
        case 'de':
            return 'Panama';
    }
};
export const PE = lang => {
    switch (lang) {
        case 'en':
            return 'Peru';
        case 'pl':
            return 'Peru';
        case 'de':
            return 'Peru';
    }
};
export const PF = lang => {
    switch (lang) {
        case 'en':
            return 'French Polynesia';
        case 'pl':
            return 'Polinezja Francuska';
        case 'de':
            return 'Französisch-Polynesien';
    }
};
export const PG = lang => {
    switch (lang) {
        case 'en':
            return 'Papua New Guinea';
        case 'pl':
            return 'Papua-Nowa Gwinea';
        case 'de':
            return 'Papua-Neuguinea';
    }
};
export const PH = lang => {
    switch (lang) {
        case 'en':
            return 'Philippines';
        case 'pl':
            return 'Filipiny';
        case 'de':
            return 'Philippinen';
    }
};
export const PK = lang => {
    switch (lang) {
        case 'en':
            return 'Pakistan';
        case 'pl':
            return 'Pakistan';
        case 'de':
            return 'Pakistan';
    }
};
export const PL = lang => {
    switch (lang) {
        case 'en':
            return 'Poland';
        case 'pl':
            return 'Polska';
        case 'de':
            return 'Polen';
    }
};
export const PM = lang => {
    switch (lang) {
        case 'en':
            return 'Saint Pierre and Miquelon';
        case 'pl':
            return 'Saint-Pierre i Miquelon';
        case 'de':
            return 'Saint-Pierre und Miquelon';
    }
};
export const PN = lang => {
    switch (lang) {
        case 'en':
            return 'Pitcairn';
        case 'pl':
            return 'Pitcairn';
        case 'de':
            return 'Pitcairninseln';
    }
};
export const PR = lang => {
    switch (lang) {
        case 'en':
            return 'Puerto Rico';
        case 'pl':
            return 'Portoryko';
        case 'de':
            return 'Puerto Rico';
    }
};
export const PS = lang => {
    switch (lang) {
        case 'en':
            return 'Palestine';
        case 'pl':
            return 'Palestyna';
        case 'de':
            return 'Palästina';
    }
};
export const PT = lang => {
    switch (lang) {
        case 'en':
            return 'Portugal';
        case 'pl':
            return 'Portugalia';
        case 'de':
            return 'Portugal';
    }
};
export const PW = lang => {
    switch (lang) {
        case 'en':
            return 'Palau';
        case 'pl':
            return 'Palau';
        case 'de':
            return 'Palau';
    }
};
export const PY = lang => {
    switch (lang) {
        case 'en':
            return 'Paraguay';
        case 'pl':
            return 'Paragwaj';
        case 'de':
            return 'Paraguay';
    }
};
export const QA = lang => {
    switch (lang) {
        case 'en':
            return 'Qatar';
        case 'pl':
            return 'Katar';
        case 'de':
            return 'Katar';
    }
};
export const RE = lang => {
    switch (lang) {
        case 'en':
            return 'Réunion';
        case 'pl':
            return 'Reunion';
        case 'de':
            return 'Réunion';
    }
};
export const RO = lang => {
    switch (lang) {
        case 'en':
            return 'Romania';
        case 'pl':
            return 'Rumunia';
        case 'de':
            return 'Rumänien';
    }
};
export const RS = lang => {
    switch (lang) {
        case 'en':
            return 'Serbia';
        case 'pl':
            return 'Serbia';
        case 'de':
            return 'Serbien';
    }
};
export const RU = lang => {
    switch (lang) {
        case 'en':
            return 'Russia';
        case 'pl':
            return 'Rosja';
        case 'de':
            return 'Russland';
    }
};
export const RW = lang => {
    switch (lang) {
        case 'en':
            return 'Rwanda';
        case 'pl':
            return 'Rwanda';
        case 'de':
            return 'Ruanda';
    }
};
export const SA = lang => {
    switch (lang) {
        case 'en':
            return 'Saudi Arabia';
        case 'pl':
            return 'Arabia Saudyjska';
        case 'de':
            return 'Saudi-Arabien';
    }
};
export const SB = lang => {
    switch (lang) {
        case 'en':
            return 'Solomon Islands';
        case 'pl':
            return 'Wyspy Salomona';
        case 'de':
            return 'Salomonen';
    }
};
export const SC = lang => {
    switch (lang) {
        case 'en':
            return 'Seychelles';
        case 'pl':
            return 'Seszele';
        case 'de':
            return 'Seychellen';
    }
};
export const SD = lang => {
    switch (lang) {
        case 'en':
            return 'Sudan';
        case 'pl':
            return 'Sudan';
        case 'de':
            return 'Sudan';
    }
};
export const SE = lang => {
    switch (lang) {
        case 'en':
            return 'Sweden';
        case 'pl':
            return 'Szwecja';
        case 'de':
            return 'Schweden';
    }
};
export const SG = lang => {
    switch (lang) {
        case 'en':
            return 'Singapore';
        case 'pl':
            return 'Singapur';
        case 'de':
            return 'Singapur';
    }
};
export const SH = lang => {
    switch (lang) {
        case 'en':
            return 'Saint Helena, Ascension and Tristan da Cunha';
        case 'pl':
            return 'Wyspa Świętej Heleny, Wyspa Wniebowstąpienia i Tristan da Cunha';
        case 'de':
            return 'St. Helena, Ascension und Tristan da Cunha';
    }
};
export const SI = lang => {
    switch (lang) {
        case 'en':
            return 'Slovenia';
        case 'pl':
            return 'Słowenia';
        case 'de':
            return 'Slowenien';
    }
};
export const SJ = lang => {
    switch (lang) {
        case 'en':
            return 'Svalbard and Jan Mayen';
        case 'pl':
            return 'Svalbard i Jan Mayen';
        case 'de':
            return 'Svalbard und Jan Mayen';
    }
};
export const SK = lang => {
    switch (lang) {
        case 'en':
            return 'Slovakia';
        case 'pl':
            return 'Słowacja';
        case 'de':
            return 'Slowakei';
    }
};
export const SL = lang => {
    switch (lang) {
        case 'en':
            return 'Sierra Leone';
        case 'pl':
            return 'Sierra Leone';
        case 'de':
            return 'Sierra Leone';
    }
};
export const SM = lang => {
    switch (lang) {
        case 'en':
            return 'San Marino';
        case 'pl':
            return 'San Marino';
        case 'de':
            return 'San Marino';
    }
};
export const SN = lang => {
    switch (lang) {
        case 'en':
            return 'Senegal';
        case 'pl':
            return 'Senegal';
        case 'de':
            return 'Senegal';
    }
};
export const SO = lang => {
    switch (lang) {
        case 'en':
            return 'Somalia';
        case 'pl':
            return 'Somalia';
        case 'de':
            return 'Somalia';
    }
};
export const SR = lang => {
    switch (lang) {
        case 'en':
            return 'Suriname';
        case 'pl':
            return 'Surinam';
        case 'de':
            return 'Suriname';
    }
};
export const SS = lang => {
    switch (lang) {
        case 'en':
            return 'South Sudan';
        case 'pl':
            return 'Sudan Południowy';
        case 'de':
            return 'Südsudan';
    }
};
export const ST = lang => {
    switch (lang) {
        case 'en':
            return 'São Tomé and Príncipe';
        case 'pl':
            return 'Wyspy Świętego Tomasza i Książęca';
        case 'de':
            return 'São Tomé und Príncipe';
    }
};
export const SV = lang => {
    switch (lang) {
        case 'en':
            return 'El Salvador';
        case 'pl':
            return 'Salwador';
        case 'de':
            return 'El Salvador';
    }
};
export const SX = lang => {
    switch (lang) {
        case 'en':
            return 'Sint Maarten';
        case 'pl':
            return 'Sint Maarten';
        case 'de':
            return 'Sint Maarten';
    }
};
export const SY = lang => {
    switch (lang) {
        case 'en':
            return 'Syria';
        case 'pl':
            return 'Syria';
        case 'de':
            return 'Syrien';
    }
};
export const SZ = lang => {
    switch (lang) {
        case 'en':
            return 'Eswatini';
        case 'pl':
            return 'Eswatini';
        case 'de':
            return 'Eswatini';
    }
};
export const TC = lang => {
    switch (lang) {
        case 'en':
            return 'Turks and Caicos Islands';
        case 'pl':
            return 'Turks i Caicos';
        case 'de':
            return 'Turks- und Caicosinseln';
    }
};
export const TD = lang => {
    switch (lang) {
        case 'en':
            return 'Chad';
        case 'pl':
            return 'Czad';
        case 'de':
            return 'Tschad';
    }
};
export const TF = lang => {
    switch (lang) {
        case 'en':
            return 'French Southern Territories';
        case 'pl':
            return 'Francuskie Terytoria Południowe i Antarktyczne';
        case 'de':
            return 'Französische Süd- und Antarktisgebiete';
    }
};
export const TG = lang => {
    switch (lang) {
        case 'en':
            return 'Togo';
        case 'pl':
            return 'Togo';
        case 'de':
            return 'Togo';
    }
};
export const TH = lang => {
    switch (lang) {
        case 'en':
            return 'Thailand';
        case 'pl':
            return 'Tajlandia';
        case 'de':
            return 'Thailand';
    }
};
export const TJ = lang => {
    switch (lang) {
        case 'en':
            return 'Tajikistan';
        case 'pl':
            return 'Tadżykistan';
        case 'de':
            return 'Tadschikistan';
    }
};
export const TK = lang => {
    switch (lang) {
        case 'en':
            return 'Tokelau';
        case 'pl':
            return 'Tokelau';
        case 'de':
            return 'Tokelau';
    }
};
export const TL = lang => {
    switch (lang) {
        case 'en':
            return 'Timor-Leste';
        case 'pl':
            return 'Timor Wschodni';
        case 'de':
            return 'Timor-Leste';
    }
};
export const TM = lang => {
    switch (lang) {
        case 'en':
            return 'Turkmenistan';
        case 'pl':
            return 'Turkmenistan';
        case 'de':
            return 'Turkmenistan';
    }
};
export const TN = lang => {
    switch (lang) {
        case 'en':
            return 'Tunisia';
        case 'pl':
            return 'Tunezja';
        case 'de':
            return 'Tunesien';
    }
};
export const TO = lang => {
    switch (lang) {
        case 'en':
            return 'Tonga';
        case 'pl':
            return 'Tonga';
        case 'de':
            return 'Tonga';
    }
};
export const TR = lang => {
    switch (lang) {
        case 'en':
            return 'Turkey';
        case 'pl':
            return 'Turcja';
        case 'de':
            return 'Türkei';
    }
};
export const TT = lang => {
    switch (lang) {
        case 'en':
            return 'Trinidad and Tobago';
        case 'pl':
            return 'Trynidad i Tobago';
        case 'de':
            return 'Trinidad und Tobago';
    }
};
export const TV = lang => {
    switch (lang) {
        case 'en':
            return 'Tuvalu';
        case 'pl':
            return 'Tuvalu';
        case 'de':
            return 'Tuvalu';
    }
};
export const TW = lang => {
    switch (lang) {
        case 'en':
            return 'Taiwan';
        case 'pl':
            return 'Tajwan';
        case 'de':
            return 'Taiwan';
    }
};
export const TZ = lang => {
    switch (lang) {
        case 'en':
            return 'Tanzania';
        case 'pl':
            return 'Tanzania';
        case 'de':
            return 'Tansania';
    }
};
export const UA = lang => {
    switch (lang) {
        case 'en':
            return 'Ukraine';
        case 'pl':
            return 'Ukraina';
        case 'de':
            return 'Ukraine';
    }
};
export const UG = lang => {
    switch (lang) {
        case 'en':
            return 'Uganda';
        case 'pl':
            return 'Uganda';
        case 'de':
            return 'Uganda';
    }
};
export const UM = lang => {
    switch (lang) {
        case 'en':
            return 'United States Minor Outlying Islands';
        case 'pl':
            return 'Dalekie Wyspy Mniejsze Stanów Zjednoczonych';
        case 'de':
            return 'Kleinere Inselbesitzungen der Vereinigten Staaten';
    }
};
export const US = lang => {
    switch (lang) {
        case 'en':
            return 'United States';
        case 'pl':
            return 'Stany Zjednoczone';
        case 'de':
            return 'Vereinigte Staaten';
    }
};
export const UY = lang => {
    switch (lang) {
        case 'en':
            return 'Uruguay';
        case 'pl':
            return 'Urugwaj';
        case 'de':
            return 'Uruguay';
    }
};
export const UZ = lang => {
    switch (lang) {
        case 'en':
            return 'Uzbekistan';
        case 'pl':
            return 'Uzbekistan';
        case 'de':
            return 'Usbekistan';
    }
};
export const VA = lang => {
    switch (lang) {
        case 'en':
            return 'Vatican City';
        case 'pl':
            return 'Watykan';
        case 'de':
            return 'Vatikanstadt';
    }
};
export const VC = lang => {
    switch (lang) {
        case 'en':
            return 'Saint Vincent and the Grenadines';
        case 'pl':
            return 'Saint Vincent i Grenadyny';
        case 'de':
            return 'St. Vincent und die Grenadinen';
    }
};
export const VE = lang => {
    switch (lang) {
        case 'en':
            return 'Venezuela';
        case 'pl':
            return 'Wenezuela';
        case 'de':
            return 'Venezuela';
    }
};
export const VG = lang => {
    switch (lang) {
        case 'en':
            return 'British Virgin Islands';
        case 'pl':
            return 'Brytyjskie Wyspy Dziewicze';
        case 'de':
            return 'Britische Jungferninseln';
    }
};
export const VI = lang => {
    switch (lang) {
        case 'en':
            return 'U.S. Virgin Islands';
        case 'pl':
            return 'Wyspy Dziewicze Stanów Zjednoczonych';
        case 'de':
            return 'Amerikanische Jungferninseln';
    }
};
export const VN = lang => {
    switch (lang) {
        case 'en':
            return 'Vietnam';
        case 'pl':
            return 'Wietnam';
        case 'de':
            return 'Vietnam';
    }
};
export const VU = lang => {
    switch (lang) {
        case 'en':
            return 'Vanuatu';
        case 'pl':
            return 'Vanuatu';
        case 'de':
            return 'Vanuatu';
    }
};
export const WF = lang => {
    switch (lang) {
        case 'en':
            return 'Wallis and Futuna';
        case 'pl':
            return 'Wallis i Futuna';
        case 'de':
            return 'Wallis und Futuna';
    }
};
export const WS = lang => {
    switch (lang) {
        case 'en':
            return 'Samoa';
        case 'pl':
            return 'Samoa';
        case 'de':
            return 'Samoa';
    }
};
export const XK = lang => {
    switch (lang) {
        case 'en':
            return 'Kosovo';
        case 'pl':
            return 'Kosowo';
        case 'de':
            return 'Kosovo';
    }
};
export const YE = lang => {
    switch (lang) {
        case 'en':
            return 'Yemen';
        case 'pl':
            return 'Jemen';
        case 'de':
            return 'Jemen';
    }
};
export const YT = lang => {
    switch (lang) {
        case 'en':
            return 'Mayotte';
        case 'pl':
            return 'Majotta';
        case 'de':
            return 'Mayotte';
    }
};
export const ZA = lang => {
    switch (lang) {
        case 'en':
            return 'South Africa';
        case 'pl':
            return 'Republika Południowej Afryki';
        case 'de':
            return 'Südafrika';
    }
};
export const ZM = lang => {
    switch (lang) {
        case 'en':
            return 'Zambia';
        case 'pl':
            return 'Zambia';
        case 'de':
            return 'Sambia';
    }
};
export const ZW = lang => {
    switch (lang) {
        case 'en':
            return 'Zimbabwe';
        case 'pl':
            return 'Zimbabwe';
        case 'de':
            return 'Simbabwe';
    }
};
//# sourceMappingURL=Country.loc.js.map